import React from "react";
import meditationDay from "../images/Dec21.jpeg";
import "../WorldMeditationDay.css"; // import the CSS file

const WorldMeditationDay = () => {
  return (
    <section className="meditation-section">
      <div className="meditation-container">
        <h1 className="meditation-title">✨🧘 World Meditation Day!🧘✨</h1>

        <img
          src={meditationDay}
          alt="World Meditation Day"
          className="meditation-image"
        />

        <div className="meditation-content">
          <p>
            You know the power within you. You know that a moment of stillness
            can reshape a whole day, and that consistent peace can redefine a
            life.
          </p>

          <p>
            On World Meditation Day, let's move beyond knowing and step into
            doing, together. This is more than an event—it's a global call to
            action, a chance to collectively shift the energy of our planet.
          </p>

          <p>
            Imagine the ripple effect: Thousands of minds finding calm,
            thousands of hearts opening to compassion. By meditating with us,
            you aren't just improving your own life; you are actively
            contributing to a more peaceful, centered world.
          </p>

          <p>Don't just believe in transformation—become the transformation.</p>

          <p>It's time to show the world what's possible.</p>

          <a
            href="https://oneworldmeditation.org"
            target="_blank"
            rel="noopener noreferrer"
            className="register-button"
          >
            Register Now
          </a>

          <p className="closing-text">
            Let's unite, meditate, and make this a day that truly transforms
            ourselves and our world!
          </p>
        </div>
      </div>
    </section>
  );
};

export default WorldMeditationDay;
